/** API route map: URLS.Controller.ClientInvoice */
export const ClientInvoice = {
      Name: 'ClientInvoice/',
      Add: 'add',
      UploadPdf: 'upload-invoice',
      GetAll: 'invoices',
      Tiles: 'tiles',
      pay: 'pay',
      InvoiceTimeSheet: 'add-invoice-time-sheet',
      GetInvoiceDetail: 'get-invoice-detail',
      AddCollection: 'add-collection',
      GetCollection: 'get-collections',
      GetCollectionNotes: 'get-collection-notes',
      AddCollectionNote: 'add-collection-note',
      AddPayrollInvoice: 'add-invoice-payroll',
};
